module.exports = ".long-menu {\n  max-height: 300px;\n  overflow: scroll;\n}\n::ng-deep .long-menu > .mat-menu-content {\n  max-height: 300px;\n  overflow-y: scroll;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/shot/shot-chart-menu/shot-chart-menu.component.less
// module id = ./src/app/projects/shot/shot-chart-menu/shot-chart-menu.component.less
// module chunks = main